export default "__VITE_ASSET__673673b6__"